
// これはテスト

module.exports.hello = () => {
    console.log("hello.");
}

module.exports.composeURL_with_argument = (baseURL,ary_argument,argument_name='json') => {
    let param = new URLSearchParams();

    if(baseURL.endsWith('?')) baseURL.substring(0,baseURL.length-1);
    
    param.append(argument_name,encodeURIComponent(JSON.stringify(ary_argument)));
    return `${baseURL}?${param.toString()}`;
}

/**
 * exprで表される式が呼び出し可能なオブジェクトを表すかチェックする。
 * @param { * } expr オブジェクトを表す式
 * @returns { boolean } 式 expr が 呼び出し可能ならtrue
 */
module.exports.is_callable = (expr) => {
    return [
        (expr),
        (typeof expr === 'function')
    ].every(e=>e);

}

module.exports.to_half = (str)=>{
    return str.replace(/[ー−―‐ー−]/g, "-").replace(/[Ａ-Ｚａ-ｚ０-９－！”＃＄％＆’（）＝＜＞，．？＿［］｛｝＠＾～￥]/g, function(s)
    {
        return String.fromCharCode(s.charCodeAt(0) - 65248);
    });
}
